import React from "react";

import './ToggleButton.scss';

const ToggleButton = props => {
	const {options, onToggle, value} = props;

	return (
		<div className="toggle-button-component-container" onClick={() => onToggle(value)}>
			{ options.map((op, i) => <div className={op === value ? 'toggle-button-option-on' : 'toggle-button-option-off'} key={i}>{op}</div> )}
		</div>
	)
};

export default ToggleButton;